export class ICDTransportModel {
  public icdId: string;
  public value: any;
  public errorMsg: string;

  constructor(icdId: string, value?: any, error?: string) {
    this.icdId = icdId;
    this.value = value != null ? value : null;
    this.errorMsg = typeof error === "string" && error.length > 0 ? error : null;
  }
}
